import { ensureArray } from '@zapier/common-utils';

const partialWithDefault = (fn, outerArgs = [], defaultValue) => (
  ...innerArgs
) => {
  const result = fn(...ensureArray(outerArgs), ...innerArgs);
  return result === undefined || result === null ? defaultValue : result;
};

export default partialWithDefault;
